/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Load_Not_PositiveInputs */

const en_us2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The load has to be above zero. Leave it empty for bodyweight.`)
};

const pt_br2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carga precisa ser maior que zero. Deixe em branco para peso corporal.`)
};

const es_419_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso tiene que ser mayor que cero. Déjalo vacío para peso corporal.`)
};

const pt_pt2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carga tem de ser maior do que zero. Deixa em branco para peso corporal.`)
};

const fr_fr2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge doit être supérieure à zéro. Laisse vide pour le poids de corps.`)
};

const de_de2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Gewicht muss über null liegen. Lass es für Körpergewicht leer.`)
};

const it_it2_workout_load_not_positive = /** @type {(inputs: Workout_Load_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il carico deve essere maggiore di zero. Lascialo vuoto per il corpo libero.`)
};

/**
* | output |
* | --- |
* | "The load has to be above zero. Leave it empty for bodyweight." |
*
* @param {Workout_Load_Not_PositiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_load_not_positive = /** @type {((inputs?: Workout_Load_Not_PositiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Load_Not_PositiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_load_not_positive(inputs)
	if (locale === "es-419") return es_419_workout_load_not_positive(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_load_not_positive(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_load_not_positive(inputs)
	if (locale === "de-DE") return de_de2_workout_load_not_positive(inputs)
	if (locale === "it-IT") return it_it2_workout_load_not_positive(inputs)
	return en_us2_workout_load_not_positive(inputs)
});
export { workout_load_not_positive as "workout.load_not_positive" }